import { BroadbandCartItem } from './broadband-cart-item';
import { MobileCartItem } from './mobile-cart-item';

const Cart = () => {
  return (
    <div className="flex flex-col gap-4 md:gap-6">
      <BroadbandCartItem />
      <MobileCartItem />
    </div>
  );
};

export { Cart };
